// 🔥 Trekkin.app — firebaseConfig.js
// 🔹 Mantém tudo o resto intacto (Regra de Ouro)

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";   // 🆕 STORAGE

console.log("🔥 FIREBASECONFIG CARREGADO!");

const firebaseConfig = {
  apiKey: "AIzaSyBAw86VN77OgmU_1g2lTITz0yfI8QDh6k4",
  authDomain: "trekkinapp-95c80.firebaseapp.com",
  databaseURL:
    "https://trekkinapp-95c80-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "trekkinapp-95c80",

  // Bucket real configurado no projeto Firebase (GoogleService-Info.plist
  // e google-services.json usam o mesmo valor).
  storageBucket: "trekkinapp-95c80.firebasestorage.app",

  messagingSenderId: "840515895622",
  appId: "1:840515895622:web:ad3aefa9b9915488f66547",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);
export const storage = getStorage(app); // 🆕 EXPORT STORAGE

// Debug opcional
if (typeof window !== "undefined") {
  window.__trekkin_app = app;
  window.__trekkin_db = db;
  window.__trekkin_storage = storage; // 🆕
}
